import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-back_icon",
  "use": "icon-back_icon-usage",
  "viewBox": "0 0 20 16",
  "content": "<symbol viewBox=\"0 0 20 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-back_icon\"><path d=\"M8 15L1 8M1 8L8 1M1 8L19 8\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol